import React, { Component } from 'react'
import './index.less'
interface RemarkCellProps {
    remark: string
}
export default class RemarkCell extends Component<RemarkCellProps> {
    render() {
        return (
            <div className='remark-content'>
                <span className='remark-title'>备注留言</span>
                <span className='remark-brief'>{this.props.remark}</span>
            </div>
        )
    }
}